import React from 'react';
import PropTypes from 'prop-types';

const SqcRow = (props) => {

    const {label, value} = props;

    return (
        <div className="row">
            <div className="col s4 right-align">
                {label}:

            </div>
            <div className="col s8 left-align">
                {value}
            </div>
        </div>

    );
};

SqcRow.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string

};
export default SqcRow;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcRow.js